import * as WebBrowser from 'expo-web-browser';
import { useState } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { Divider } from 'react-native-paper';

import { NonProfitOrgProfileResponse } from '@/api/models/nonProfitOrgModels';
import BrandedButton from '@/components/buttons/BrandedButton';
import Text from '@/components/Text';
import { useEndFlowModal } from '@/contexts/endFlowModalContext';
import { useColor } from '@/hooks/useColor';
import { firebaseImage, safeJsonParseArray } from '@/utils/firebaseImage';
import { i18n } from '@/utils/i18n';

const NineNinetyItem = ({ nineNintyForm }: { nineNintyForm: NonProfitOrgProfileResponse['nineNintyForm'] }) => {
  const [isLoadingNineNinty, setIsLoadingNineNinty] = useState(false);
  const { showError } = useEndFlowModal();

  const colors = useColor();

  const nineNintyFormParsed = safeJsonParseArray(nineNintyForm ?? '[]');

  const onPressNineNinty = async () => {
    if (nineNintyFormParsed) {
      setIsLoadingNineNinty(true);
      try {
        let url = firebaseImage(nineNintyFormParsed?.at(0));
        await WebBrowser.openBrowserAsync(url);
      } catch {
        showError({});
      }
      setIsLoadingNineNinty(false);
    }
  };

  return (
    <View>
      <View style={styles.titleContainer}>
        <View style={styles.titleContent}>
          <Text style={[styles.titleText, { color: colors.titleText }]} fontWeight="700">
            {i18n.t('npo_details.insights.nineNinetyForm')}
          </Text>
        </View>
      </View>
      <View style={styles.content}>
        {nineNintyFormParsed && nineNintyFormParsed.length > 0 ? (
          <BrandedButton style={styles.button} onPress={onPressNineNinty} loading={isLoadingNineNinty}>
            {i18n.t('npo_details.insights.nineNinetyForm_button')}
          </BrandedButton>
        ) : (
          <Text> {i18n.t('mix.n_a')}</Text>
        )}
      </View>
      <Divider />
    </View>
  );
};

export default NineNinetyItem;

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  titleContent: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center'
  },

  titleText: {
    fontSize: 22,
    marginRight: 10
  },

  content: {
    marginTop: 10,
    marginBottom: 20
  },

  button: {
    borderRadius: 20,
    width: Platform.OS !== 'web' ? '50%' : '100%',
    height: 34
  }
});
